import napStyles from './../napRtl.json'

const headText = {
  paragraphType: 'Label',
  paragraphTagName: 'h3',
  paragraphName: '1',
  letterSpacing: 0,
  marginLeft: 4,
  marginTop: 5,
  color: napStyles.colors.SecondaryGreyMetal
}

const preTitle = {
  borderTopColor: napStyles.colors.SecondaryGreySteel,
  letterSpacing: 0,
  color: napStyles.colors.SecondaryGreyMetal,
  textAlign: 'left',
  textAlignMedium: 'left',
  fontSize: 14,
  fontSizeMedium: 14,
  paragraphType: 'Label',
  paragraphTagName: 'h4',
  paragraphName: '1'
}

const title = {
  color: 'black',
  marginTopMultiplier: 0,
  marginTopMultiplierMedium: 0,
  marginTopMultiplierLarge: 0,
  marginBottomMultiplier: 2,
  marginBottomMultiplierMedium: 2,
  marginBottomMultiplierLarge: 2,
  fontSize: 80,
  fontSizeMedium: 64,
  fontSizeLarge: 64,
  fontSizeXLarge: 100,
  lineHeight: '88px',
  lineHeightMedium: '72px',
  lineHeightLarge: '72px',
  lineHeightXLarge: '108px',
  fontSizeAlphaNum: 32,
  fontSizeAlphaNumLarge: 48,
  lineHeightAlphaNum: 1.25,
  textAlign: 'left',
  paragraphType: 'Heading',
  paragraphTagName: 'h3',
  paragraphName: 'B1'
}

const text = {
  fontSize: 16,
  fontSizeMedium: 16,
  fontSizeLarge: 16,
  textAlign: 'left',
  textAlignMedium: 'left',
  marginBottom: 3
}

const marginMultipliers = {
  desktopLeft: 0,
  desktopRight: 1,
  tabletLeft: 0,
  tabletRight: 1,
  mobileLeft: 2,
  mobileRight: 0,
  bottomDivider: 2,
  arrowRight: 6.5,
  arrowRightLarge: 7,
  arrowLeft: 7,
  arrowLeftLarge: 7.5,
  rtlArrow: 5.5,
  rtlArrowLarge: 4.5
}

const paddingMultipliers = {
  mobileLeft: 2,
  mogileRight: 0,
  mobileBorderTop: 0,
  tabletBorderTop: 0,
  desktopBorderTop: 0
}

const heights = {
  mobile: 545,
  medium: 300,
  large: 260,
  xLarge: 370
}

const pids = {
  shadow: false,
  defaultWidth: 206,
  defaultHeight: 250,
  pidPadding: false,
  skeletonBottonMargin: 0,
  imageAspectRatio: 1.5
}

// tier expansion

const tierHeights = {
  mobile: '545px',
  medium: '380px',
  large: '30vw',
  xLarge: '428px'
}

const tierGredient = {
  eip:  'linear-gradient(304deg, #9b825c -2.2%, #6b492a 85.03%)',
  eipplatinum: 'linear-gradient(311deg, #aca59d -25.42%, #7d6e64 31.48%, #43444a 91.91%)'
}

// tier expansion end

export default {
  preTitle,
  title,
  text,
  marginMultipliers,
  paddingMultipliers,
  heights,
  pids,
  headText,
  tierHeights,
  tierGredient
}
